/* eslint-disable max-len */
// i18next-extract-mark-ns-start LandingAds
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Container, Content } from '../../components/home/v2/styledComponents';
import MenuBar from '../../components/home/MenuBar';
import Footer from '../../components/home/v3/Footer';
import Layout from '../../layouts/index';
import CoutureServices from '../../components/home/OurServices/CoutureServices';

// eslint-disable-next-line max-lines-per-function
export const getFAQ = (t, city, curtainsVersion) => [
  {
    question: t('Comment se déroule le rendez-vous avec le couturier ?'),
    answer: curtainsVersion
      ? t('Notre couturier se déplace chez vous. Rideaux accrochés, vous déterminerez avec lui les retouches à effectuer en fonction des dimensions de vos fenêtres, de votre pièce et de vos envies évidemment. Pensez à bien prévoir le nécessaire pour ensuite décrocher les rideaux et les remettre au couturier. Il repartira avec pour réaliser les retouches dans son atelier.')
      : t('Même principe que chez un retoucheur, mais à domicile ! Notre couturier se déplace chez vous. Prenez le temps d\'essayer les vêtements et de bien expliquer ce que vous souhaitez. Notre couturier prend les marques et mesures nécessaires, et repart ensuite avec vos vêtements pour réaliser les retouches dans son atelier.'),
  },
  {
    question: t('Est-ce que j’ai des choses à préparer avant mon rendez-vous ?'),
    answer: curtainsVersion
      ? t('Suspendez vos rideaux 48h au moins avant le RDV pour que le tissu soit bien détendu. Veillez aussi à prévoir le nécessaire pour les décrocher de leur tringle. Si les rideaux sont lourds et difficiles à décrocher, les retouches se feront exceptionnellement sur place.')
      : t('Uniquement un petit tas avec vos vêtements propres à retoucher. Si besoin, nos couturiers fournissent les basiques (boutons, élastiques, doublures, zips, thermocollants) dans les coloris classiques. En revanche pour les autres demandes avec une forme ou un coloris particulier, veillez bien à vous les procurer avant.'),
  },
  {
    question: t('Quels sont les horaires de vos couturiers ?'),
    answer: t('Nos couturiers peuvent venir chez vous de 7h à 22h toute la semaine et y compris le week-end ! Quand on vous dit que Tilli vous simplifie la vie ?'),
  },
  {
    question: curtainsVersion
      ? t('Comment ça se passe si mes rideaux sont trop lourds ou impossibles à décrocher ?')
      : t('Les retouches peuvent-elles se faire sur place si c’est urgent ?'),
    answer: curtainsVersion
      ? t('Exceptionnellement les retouches peuvent se faire sur place. Dans ce cas, veillez bien à prévoir une planche à repasser, de l’espace et de la lumière pour que le couturier soit dans de bonnes conditions de travail et que les retouches soient réussies :) !')
      : t('Les retouches se font dans les ateliers de nos couturiers. Pour les demandes urgentes, on essaiera quand même de vous arranger des retouches sur place. Tout dépendra de la disponibilité de nos couturiers et de la retouche à faire. Pour ça, le mieux c’est de nous contacter directement par mail à contact@tilli.fr. '),
  },
  {
    question: t('J’habite loin, vous vous déplacez quand même ?'),
    answer: ((_) => {
      if (city === 'Paris') {
        return t('Nos couturiers se déplacent dans toute l’Ile-de-France. Les frais de déplacement des couturiers sont de 5 € et exceptionnellement de 15 € pour les villes situées dans la grande couronne ou celles qui ne sont pas desservies par le métro.');
      } if (city === 'Lyon') {
        return t('Pour le moment, nos couturiers se déplacent à Lyon, Villeurbanne et St Foy. Si vous habitez proche, contactez-nous.');
      }
      return t('Nos couturiers se déplacent à Paris et sa proche banlieue, Lyon, Marseille, Bruxelles, Aix en Provence, Bordeaux, Toulouse, Lille, Rennes, Nantes, Strasbourg, Nice, Cannes, Montpellier, Nimes, Metz, Grenoble, Caen, Rouen et Tours. Si vous habitez proche d’une de ces villes, contactez-nous.');
    })(),
  },
  {
    question: t('Quels sont les délais de livraison une fois le produit retouché ?'),
    answer: curtainsVersion
      ? t('En moyenne 3 jours. Selon la complexité de la retouche ou le nombre de rideaux ou voilages, les délais peuvent variés. Le couturier prendra soin de vous prévenir évidemment. ')
      : t('En moyenne 3 jours. Mais si la demande est forte ou les retouches demandées plus complexes, ça peut prendre un peu plus de temps. Dans ce cas, le couturier vous prévient évidemment.'),
  },
  {
    question: t('Comment je fais mon devis si je ne connais pas les retouches ?'),
    answer: t('L’estimation que vous faites lors de la prise de RDV vous permet juste d’avoir une estimation du coût. Mais le devis n’est pas figé. Vous verrez directement avec notre couturier en RDV les retouches à réaliser et il réajustera l’estimation si besoin. Vous pouvez d’ailleurs choisir de prendre RDV en 3 clics si vous ne souhaitez pas détailler les retouches.'),
  },
  {
    question: t('Votre service est-il plus cher qu’un retoucheur classique ?'),
    answer: curtainsVersion
      ? t('Tilli applique les mêmes tarifs que les retoucheries de quartier. Pour vous donner une idée, l’ourlet est à 20 € sur un rideau dont la largeur est inférieure à 2m, et à 30 € si elle est supérieure à 2m. On vous facture juste 5 € en plus pour couvrir les frais de déplacement de nos couturiers chez vous.')
      : t('Tilli applique les mêmes tarifs que les retoucheries de quartier. Pour vous donner une idée, l’ourlet simple est à 12 €. On vous facture juste 5 € en plus pour couvrir les frais de déplacement de nos couturiers chez vous.'),
  },
  {
    question: t('Y a-t-il des frais d’annulation ?'),
    answer: t('Les annulations sont gratuites jusqu\'à 15 heures avant le rendez-vous. Pour dédommager les couturiers en cas d’annulation tardive, on prélève des frais d’annulation. 14 € pour une annulation entre 15h et 2h avant le rendez-vous, et 25 € lorsque c’est moins de 2h avant.'),
  },
  {
    question: t('Que se passe-t-il en cas de soucis avec mes retouches ?'),
    answer: t('Un souci avec les retouches ? On n\'y croit pas vraiment, mais au cas où on a prévu le coup ;) Une assurance MMA est incluse pour chaque commande et couvre tous les vêtements confiés à nos couturiers pendant la durée de la commande. Mais on a jamais eu besoin de s’en servir.'),
  },
  {
    question: t('Quand suis-je débité ?'),
    answer: t('Vous serez débité après le 1er RDV. Si on vous demande vos infos bancaires avant, c’est uniquement pour bloquer le créneau avec nos couturiers :)'),
  },
];

function LandingAds({
  pageContext: {
    slug, city, locality, faqQuestions = [], preFilledSteps, fabric,
  },
}) {
  const { t } = useTranslation();

  faqQuestions = [...faqQuestions, ...getFAQ(t, city, fabric === 'curtains')].map((faqQuestion) => {
    faqQuestion.answers = faqQuestion.answers || [faqQuestion.answer];
    return faqQuestion;
  });

  return (
    <Layout routeSlug={slug} city={city}>
      <Container>
        <Content full hasNoBanner>
          <MenuBar />
          <CoutureServices
            locality={locality}
            faqQuestions={faqQuestions}
            preFilledSteps={preFilledSteps}
            preSelectedRange={fabric === 'curtains' ? 'interior' : 'dressing'}
          />
          <Footer />
        </Content>
      </Container>
    </Layout>
  );
}

LandingAds.propTypes = {
  pageContext: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    city: PropTypes.string,
    locality: PropTypes.string,
    fabric: PropTypes.string,
    piece: PropTypes.string,
    backgroundImage: PropTypes.shape({
      publicURL: PropTypes.string,
    }),
    mobileBackgroundImage: PropTypes.shape({
      publicURL: PropTypes.string,
    }),
    faqQuestions: PropTypes.arrayOf(PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    })),
    brands: PropTypes.arrayOf(PropTypes.shape({
      img: PropTypes.shape({
        publicURL: PropTypes.string,
      }),
      index: PropTypes.number,
    })),
    preFilledSteps: PropTypes.shape({
      selectedCloth: PropTypes.string,
      selectedFabric: PropTypes.string,
    }),
  }).isRequired,
};

export default LandingAds;
